import { render, staticRenderFns } from "./InputDate2.vue?vue&type=template&id=50c1adc7"
import script from "./InputDate2.vue?vue&type=script&lang=js"
export * from "./InputDate2.vue?vue&type=script&lang=js"
import style0 from "./InputDate2.vue?vue&type=style&index=0&id=50c1adc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports